export function getText(value) {
  return value === 'assigned'
    ? `Good Job! No incomplete assigned tasks.`
    : `Congrats! No Unassigned tasks in your subscribed stages.`
}
